// useSearchBox.ts

import {useEffect, useState } from "react";
import { SearchFieldRequestModel } from "../../models";

const useSearchBox = () => {
    const [value, setValue] = useState("");
    const [searchedWord, setSearchWord] = useState("");
    const onChange = (e: any) => setValue(e.target.value);
    const onSearch = () => setSearchWord(value);
    const onReset = () => setValue("");

    return { value, onReset, onChange, onSearch, searchedWord };
};

const useSearchBoxGeneric = (initialFields: SearchFieldRequestModel[]) => {
    const [fields, setFields] = useState<SearchFieldRequestModel[]>(initialFields);
    const [searchedFields, setSearchedFields] = useState<SearchFieldRequestModel[]>(initialFields);

    // ✅ NEW: used to force remount for SelectBox
    const [resetVersion, setResetVersion] = useState(0);

    useEffect(() => {
        // when lookups change, update lookupList/metadata but keep current values if possible
        setFields((prev) =>
            initialFields.map((nf) => {
                const old = prev.find((x) => x.key === nf.key);
                return old ? { ...nf, value: old.value } : nf;
            })
        );

        setSearchedFields((prev) =>
            initialFields.map((nf) => {
                const old = prev.find((x) => x.key === nf.key);
                return old ? { ...nf, value: old.value } : nf;
            })
        );
    }, [initialFields]);

    const onChange = (key: string, newValue: string) => {
        setFields((prev) => {
            const next = prev.map((f) => (f.key === key ? { ...f, value: newValue } : f));
            const changed = next.find((f) => f.key === key);

            if (changed?.triggerSearchOnChange) {
                // ✅ apply all current fields snapshot (fixes select + name typing)
                setSearchedFields(next);
            }

            return next;
        });
    };
    // const onChange = (key: string, newValue: string) => {
    //     setFields((prev) => {
    //         const next = prev.map((f) => (f.key === key ? { ...f, value: newValue } : f));
    //
    //         const changed = next.find((f) => f.key === key);
    //         if (changed?.triggerSearchOnChange) {
    //             // keep searchedFields in sync (add/replace)
    //             setSearchedFields((prevSearched) => {
    //                 const exists = prevSearched.some((x) => x.key === key);
    //                 if (!exists) return [...prevSearched, changed];
    //                 return prevSearched.map((x) => (x.key === key ? { ...x, value: newValue } : x));
    //             });
    //         }
    //
    //         return next;
    //     });
    // };

    const onSearch = () => setSearchedFields(fields);

    // ✅ FINAL RESET
    const onReset = () => {
        setFields((prev) => prev.map((f) => ({ ...f, value: "" })));
        setSearchedFields((prev) => prev.map((f) => ({ ...f, value: "" })));
        setResetVersion((v) => v + 1);
    };

    return { fields, onChange, onSearch, onReset, searchedFields, resetVersion };
};


export { useSearchBox, useSearchBoxGeneric };
